(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-selector"] && !Shopify.designMode) return;
  try {
    (function(){
  console.log('[SS Bundle] Script started');

  var appBlock=document.querySelector('.shopify-block.shopify-app-block:has(.rbrFastBundlePage)');
  var bundlePage=appBlock&&appBlock.querySelector('.rbrFastBundlePage');
  var popup=document.getElementById('ss-bundle-popup');
  var popupContent=popup&&popup.querySelector('.ss-bundle-popup__content');
  var openButton=document.querySelector('.ss-bundle-open-button');
  var choices=document.querySelectorAll('input[name="ss-bundle-option"]');

  console.log('[SS Bundle] Initial elements:',{
    appBlock:!!appBlock,
    bundlePage:!!bundlePage,
    popup:!!popup,
    popupContent:!!popupContent,
    openButton:!!openButton,
    choices:choices.length
  });

  if(!appBlock||!bundlePage||!popup||!popupContent){
    console.error('[SS Bundle] Missing required element. Stopping.');
    return;
  }

  if(popup.parentNode!==document.body){
    document.body.appendChild(popup);
    console.log('[SS Bundle] Popup moved to body');
  }

  function moveBundleIntoPopup(){
    if(!bundlePage.children.length){
      console.log('[SS Bundle] Bundle not populated yet');
      return false;
    }

    if(bundlePage.parentNode!==popupContent){
      console.log('[SS Bundle] Moving bundle into popup');
      popupContent.appendChild(bundlePage);
    }

    appBlock.style.display='none';
    return true;
  }

  function updateBundleChoice(){
    var selected=document.querySelector('input[name="ss-bundle-option"]:checked');

    if(!selected){
      console.log('[SS Bundle] No bundle choice selected');
      return;
    }

    console.log('[SS Bundle] Choice changed:',selected.value);

    if(selected.value==='bundle'){
      openButton.style.display='block';
    }else{
      openButton.style.display='none';
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden','true');
    }
  }

  function openPopup(){
    console.log('[SS Bundle] Opening popup');

    moveBundleIntoPopup();

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden','false');
  }

  function closePopup(){
    console.log('[SS Bundle] Closing popup');

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden','true');
  }

  choices.forEach(function(choice){
    choice.addEventListener('change',updateBundleChoice);
  });

  openButton.addEventListener('click',openPopup);

  var closeButton=popup.querySelector('.ss-bundle-popup__close');
  var backdrop=popup.querySelector('.ss-bundle-popup__backdrop');

  if(closeButton){
    closeButton.addEventListener('click',closePopup);
  }

  if(backdrop){
    backdrop.addEventListener('click',closePopup);
  }

  var bundleObserver=new MutationObserver(function(mutations){
    var relevant=false;

    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){
        if(node.nodeType!==1)return;

        if(
          node.matches('.rbr-hrProducts__container,.rbr-total-box') ||
          node.querySelector('.rbr-hrProducts__container,.rbr-total-box')
        ){
          relevant=true;
        }
      });
    });

    if(relevant){
      console.log('[SS Bundle] Fast Bundle content detected');
      moveBundleIntoPopup();
    }
  });

  bundleObserver.observe(bundlePage,{
    childList:true,
    subtree:true
  });

  console.log('[SS Bundle] Bundle observer started');

  moveBundleIntoPopup();
  updateBundleChoice();

  setTimeout(function(){
    console.log('[SS Bundle] Initial delayed check');
    moveBundleIntoPopup();
  },500);

  setTimeout(function(){
    console.log('[SS Bundle] Second delayed check');
    moveBundleIntoPopup();
  },1500);


  function ssWatchBundleButton(){
    var popupContent=document.querySelector('.ss-bundle-popup__content');
    if(!popupContent)return;

    function updateButton(button){
      var loader=button.querySelector('.rbr-loader');
      button.classList.toggle('rbr-bundle-loading',!!loader);
    }

    function watchButton(button){
      if(button.dataset.ssButtonWatcher)return;

      button.dataset.ssButtonWatcher='true';
      updateButton(button);

      new MutationObserver(function(){
        updateButton(button);
      }).observe(button,{
        childList:true,
        subtree:true
      });
    }

    function findButtons(){
      popupContent.querySelectorAll('.rbr-addBundleBtn-container.rbr-addBundleBtn-container--minimal').forEach(watchButton);
    }

    findButtons();

    new MutationObserver(findButtons).observe(popupContent,{
      childList:true,
      subtree:true
    });
  }

  ssWatchBundleButton()
})();


/*
============================================================
BUNDLE INFO UPDATE — CURRENTLY DISABLED
============================================================

This is kept here so we can re-enable it later.

It currently updates:

- Bundle discount percentage
- Bundle saving amount
- Bundle product names
- Original bundle price
- Final bundle price
- "You save £X (Y%)" inside the popup

============================================================
*/

function ssUpdateBundleChoice(){
  console.log('[SS Bundle] ---- Updating bundle info ----');

  var bundle=document.querySelector('.rbrFastBundlePage');

  if(!bundle){
    console.log('[SS Bundle] No .rbrFastBundlePage found');
    return false;
  }

  var productEls=Array.from(
    bundle.querySelectorAll('.rbr-hrProducts__container')
  );

  console.log('[SS Bundle] Product elements found:',productEls.length);

  var products=productEls.map(function(product){
    var title=product.querySelector('.rbr-productNamePrice__title__container a');
    return title?title.textContent.trim():'';
  }).filter(Boolean);

  console.log('[SS Bundle] Products:',products);

  var regularPriceEl=bundle.querySelector('.rbr-total-box-rawPrice .money');
  var salePriceEl=bundle.querySelector('.rbr-total-box-price .money');

  console.log('[SS Bundle] Price elements:',{
    regularPriceEl:!!regularPriceEl,
    salePriceEl:!!salePriceEl
  });

  if(!products.length||!regularPriceEl||!salePriceEl){
    console.log('[SS Bundle] Bundle data not ready yet');
    return false;
  }

  var regularPriceText=regularPriceEl.textContent.trim();
  var salePriceText=salePriceEl.textContent.trim();

  var originalPriceEl=document.querySelector('.ss-bundle-original-price');
  var finalPriceEl=document.querySelector('.ss-bundle-final-price');

  if(originalPriceEl){
    originalPriceEl.textContent=regularPriceText;
  }

  if(finalPriceEl){
    finalPriceEl.textContent=salePriceText;
  }

  console.log('[SS Bundle] Raw prices:',{
    regular:regularPriceText,
    sale:salePriceText
  });

  var regularPrice=parseFloat(
    regularPriceText.replace(/[^\d.,]/g,'').replace(',','.')
  );

  var salePrice=parseFloat(
    salePriceText.replace(/[^\d.,]/g,'').replace(',','.')
  );

  console.log('[SS Bundle] Parsed prices:',{
    regular:regularPrice,
    sale:salePrice
  });

  if(isNaN(regularPrice)||isNaN(salePrice)){
    console.error('[SS Bundle] Could not parse prices');
    return false;
  }

  var savingAmount=regularPrice-salePrice;

  var savingPercentage=Math.round(
    (savingAmount/regularPrice)*100
  );

  var formattedSaving=savingAmount%1===0
    ?savingAmount.toFixed(0)
    :savingAmount.toFixed(2);

  var currency=regularPriceText.replace(/[\d.,\s]/g,'');

  console.log('[SS Bundle] Calculated savings:',{
    amount:savingAmount,
    percentage:savingPercentage,
    formatted:formattedSaving,
    currency:currency
  });

  var discountEl=document.querySelector('.ss-bundle-discount');
  var savingEl=document.querySelector('.ss-bundle-saving');
  var productsEl=document.querySelector('.ss-bundle-products');

  console.log('[SS Bundle] Choice elements:',{
    discountEl:!!discountEl,
    savingEl:!!savingEl,
    productsEl:!!productsEl
  });

  if(discountEl){
    discountEl.textContent=savingPercentage+'%';
  }

  if(savingEl){
    savingEl.textContent=' (Save '+currency+formattedSaving+')';
  }

  if(productsEl){
    productsEl.textContent=products.join(' + ');
  }

  console.log('[SS Bundle] Choice updated successfully');

  ssUpdatePopupSavings(
    bundle,
    regularPriceText,
    salePriceText,
    savingAmount,
    savingPercentage,
    currency,
    formattedSaving
  );

  return true;
}


function ssUpdatePopupSavings(bundle,regularPriceText,salePriceText,savingAmount,savingPercentage,currency,formattedSaving){
  console.log('[SS Bundle] Updating popup savings');

  var totalBox=bundle.querySelector('.rbr-total-box');

  if(!totalBox){
    console.log('[SS Bundle] Total box not found yet');
    return false;
  }

  var existing=totalBox.querySelector('.ss-bundle-popup-saving');

  if(!existing){
    existing=document.createElement('div');
    existing.className='ss-bundle-popup-saving';

    var pricesContainer=totalBox.querySelector('.rbr-space-between.rbr-totalBox__prices__mainContainer');

    if(pricesContainer&&pricesContainer.parentNode){
      pricesContainer.parentNode.appendChild(existing);
      console.log('[SS Bundle] Created popup savings element below Total');
    }else{
      totalBox.appendChild(existing);
      console.log('[SS Bundle] Created popup savings element at end of total box');
    }
  }

  existing.textContent='You save '+currency+formattedSaving+' ('+savingPercentage+'%)';

  console.log('[SS Bundle] Popup savings updated:',existing.textContent);

  return true;
}


/*
============================================================
TO RE-ENABLE BUNDLE INFO UPDATES LATER
============================================================

We deliberately do NOT call ssUpdateBundleChoice() anywhere
in the active code above.

When we're ready, we can hook it back into the Fast Bundle
loading flow without touching the popup/ATC functionality.

============================================================
*/
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upsells-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  function ssOpenUpsellPopup(campaign){
    var popup=document.getElementById('ss-upsell-popup');
    if(!popup||!campaign)return;

    var title=popup.querySelector('.ss-upsell-title');
    var subtitle=popup.querySelector('.ss-upsell-subtitle');
    var grid=popup.querySelector('.ss-upsell-grid');

    title.textContent=campaign.title||'Complete your look';
    subtitle.textContent=campaign.subtitle||'';

    var items=[];

    if(campaign.variants&&campaign.variants.length){
      campaign.variants.forEach(function(variant){
        items.push({
          id:variant.id,
          title:variant.title,
          url:variant.url,
          price:variant.price,
          image:variant.image
        });
      });
    }

    if(campaign.products&&campaign.products.length){
      campaign.products.forEach(function(product){
        items.push({
          id:product.id,
          title:product.title,
          url:product.url,
          price:product.price,
          image:product.image
        });
      });
    }

    items=items.slice(0,6);
    grid.innerHTML='';

    items.forEach(function(item){
      var card=document.createElement('div');
      card.className='ss-upsell-item';

      var link=document.createElement('a');
      link.href=item.url;

      var image=document.createElement('img');
      image.className='ss-upsell-item-image';
      image.src=item.image;
      image.alt=item.title||'';
      image.loading='lazy';

      var itemTitle=document.createElement('div');
      itemTitle.className='ss-upsell-item-title';
      itemTitle.textContent=item.title||'';

      var price=document.createElement('div');
      price.className='ss-upsell-item-price';
      price.innerHTML=item.price||'';

      var button=document.createElement('button');
      button.type='button';
      button.className='ss-upsell-item-atc';
      button.textContent='ADD TO CART';

      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();

        button.disabled=true;
        button.textContent='ADDING...';

        fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:JSON.stringify({
            items:[{
              id:item.id,
              quantity:1
            }]
          })
        })
        .then(function(response){
          if(!response.ok)throw new Error('Unable to add item');
          return response.json();
        })
        .then(function(){
          if(typeof window.SLIDECART_UPDATE==='function'){
            window.SLIDECART_UPDATE(function(){
              ssCloseUpsellPopup();
              window.SLIDECART_OPEN();
            });
          }else{
            ssCloseUpsellPopup();
            window.location.href = '/cart';
          }
        })
        .catch(function(){
          button.disabled=false;
          button.textContent='ADD TO CART';
        });
      });

      link.appendChild(image);
      link.appendChild(itemTitle);
      card.appendChild(link);
      card.appendChild(price);
      card.appendChild(button);
      grid.appendChild(card);
    });

    if(!items.length)return;

    popup.classList.add('ss-upsell-active');
    popup.setAttribute('aria-hidden','false');
  }

  function ssCloseUpsellPopup(){
    var popup=document.getElementById('ss-upsell-popup');
    if(!popup)return;
    popup.classList.remove('ss-upsell-active');
    popup.setAttribute('aria-hidden','true');
    if (typeof window.SLIDECART_UPDATE !== 'function') {
      window.location.href = '/cart';
    }
  }

  window.ssOpenUpsellPopup = ssOpenUpsellPopup;
  window.ssCloseUpsellPopup = ssCloseUpsellPopup;

  document.addEventListener('click',function(event){
    if(event.target.closest('.ss-upsell-close')||event.target.closest('.ss-upsell-skip')){
      ssCloseUpsellPopup();
      if (typeof window.SLIDECART_UPDATE !== 'function') {
        window.location.href = '/cart';
      } else {
        window.SLIDECART_OPEN();
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
